import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/livekit-ui/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/livekit-ui/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/opt/livekit-ui/node_modules/@livekit/components-styles/dist/general/index.css");
;
import(/* webpackMode: "eager" */ "/opt/livekit-ui/node_modules/@livekit/components-styles/dist/general/prefabs/index.css");
